import React, { useEffect, useState } from 'react';
import * as mentorApi from '../api/mentorApi';

export default function ActionItemsStrip({ role, onOpen }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!['program_administrator', 'counselor', 'auditor'].includes(role)) {
      setItems([]);
      return;
    }
    let cancelled = false;
    mentorApi.getActionItems()
      .then((data) => {
        if (!cancelled) setItems(data?.items || []);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => { cancelled = true; };
  }, [role]);

  if (!['program_administrator', 'counselor', 'auditor'].includes(role)) {
    return null;
  }

  return (
    <div className="action-items-strip" role="region" aria-label="Action items">
      <span className="action-items-strip-label">
        Action items
      </span>
      {items.length === 0 ? (
        <span style={{ fontSize: 13, color: '#6B7280' }}>Nothing pending.</span>
      ) : items.map((item) => (
        <button
          key={item.id || item.type}
          type="button"
          onClick={() => onOpen && onOpen(item)}
          style={{
            fontSize: 13,
            fontWeight: 700,
            color: '#0F2557',
            background: '#fff',
            border: '1px solid #E5E7EB',
            borderRadius: 16,
            padding: '5px 12px',
            cursor: 'pointer',
          }}
        >
          {item.title}
        </button>
      ))}
    </div>
  );
}
